// extracted by mini-css-extract-plugin
export default {"selector":"Rfa","disabled":"Sfa","hed":"Tfa","selected":"Ufa","subHed":"Vfa","standard":"Wfa","flavor":"Xfa","flavorImage":"Yfa","long":"Zfa"};
    if(module.hot) {
      // 1738836199242
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  